var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input",attrs:{"inputmode":"numeric"},domProps:{"value":_vm.displayValue},on:{"click":function($event){$event.stopPropagation();},"input":_vm.valueChange,"focus":_vm.onFocus,"blur":_vm.onBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }